import vars from '../helpers';
import Plyr from 'plyr';
let players = null;
let $videos = null;
let $videoClose = null;
let $video = null;
let $articlepageVideo = null;

function init(pageContainer) {
	$video = $(pageContainer).find('[data-video]');

	const template = (videoId) => {
		return `
		<div class="article-video js-article-video">
			<button class="button btn article-video__close js-article-video-close" type="button">
				<svg class="icon-close">
					<use xlink:href="./images/sprites.svg#icon-close"></use>
				</svg>
			</button>
			<div class="js-video" data-plyr-provider="youtube" data-plyr-embed-id="${videoId}"></div>
		</div>
		`;
	};

	if ($articlepageVideo) {
		$articlepageVideo.remove();
		$articlepageVideo = null;
	}

	if ($video.length) {
		vars.$body.prepend(template($video.data('video')));
	}

	$articlepageVideo = vars.$document.find('.js-article-video');
	$videoClose = $articlepageVideo.find('.js-article-video-close');
	$videos = vars.$document.find('.js-video');

	if ($videos.length || $articlepageVideo.length) {
		// eslint-disable-next-line array-callback-return
		players = Array.from($videos).map((video) => {
			// eslint-disable-next-line no-new
			const player = new Plyr(video, {
				controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen'],
				hideControls: false,
			});

			player.on('playing', () => {
				player.fullscreen.enter();
			});

			player.on('ready', () => {
				if ($articlepageVideo) {
					$articlepageVideo.addClass('is-ready');
				}
			});

			player.on('enterfullscreen', (event) => {
				vars.$body.addClass('is-video-fullscreen');
				$(event.target).parents('.article').addClass('is-contain-video-fullscreen');
			});

			player.on('exitfullscreen', () => {
				vars.$body.removeClass('is-video-fullscreen');
				$(event.target).parents('.article').removeClass('is-contain-video-fullscreen');
			});

			return player;
		});
	}

	$videoClose.on('click', (event) => {
		$(event.target).parents('.article-video').addClass('is-hidden');
		players[0].pause();
	});
}

function destroy() {
	if ($video) {
		$video = null;
	}

	if (players) {
		players.forEach((player) => {
			player.destroy();
		});

		players = null;
	}

	if ($videoClose) {
		$videoClose.off();
		$videoClose = null;
	}
}

export default {
	init,
	destroy,
};
